"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const defaultConfig = {
    currency: true,
    sign: false,
};
const formatPrice = (price, options) => {
    options = Object.assign(Object.assign({}, defaultConfig), options);
    const [integer, fractional] = price.amount.split('.');
    if (!integer && !fractional) {
        return '–';
    }
    const currency = options.currency && price.currency ? `${price.currency}\u00A0` : '';
    const sign = options.sign ? (parseFloat(price.amount) < 0 ? '-' : '+') : '';
    return `${currency}${sign}${integer}.${fractional && fractional != '0' && fractional != '00' ? fractional : '–'}`;
};
exports.default = formatPrice;
//# sourceMappingURL=formatPrice.js.map